import React from 'react';
import { Link } from 'react-router-dom';
import { HangoutInvite } from '../types';
import { formatInviteDate, formatInviteTime, inviteTypeLabel } from '../utils';
import { InviteStatusBadge, VenueImage } from './common';

// My Invites card: venue image, name, when, type, counts, and the actions this person may take.
export function InviteCard({ invite, onShare, onCancel }: { invite: HangoutInvite; onShare: (i: HangoutInvite) => void; onCancel: (i: HangoutInvite) => void }) {
  const live = invite.status === 'Active' || invite.status === 'Draft';
  return (
    <article className="hg-inv">
      <VenueImage url={invite.venue.imageUrl} alt={invite.venue.name} />
      <div className="hg-inv-body">
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, alignItems: 'flex-start' }}>
          <h3>{invite.venue.name}</h3>
          <InviteStatusBadge status={invite.isHost || invite.status !== 'Active' ? invite.status : invite.myStatus ?? invite.status} />
        </div>
        <p>{formatInviteDate(invite.inviteDateTime)} · {formatInviteTime(invite.inviteDateTime)}</p>
        <p>{inviteTypeLabel(invite.inviteType)}{invite.isHost ? ' · You\'re hosting' : ` · Hosted by ${invite.host.displayName}`}</p>
        <div className="hg-counts"><b>{invite.counts.going} Going</b><em>{invite.counts.interested} Interested</em>{invite.isHost && invite.counts.requested > 0 && <em>{invite.counts.requested} Requests</em>}</div>
        <div className="hg-inv-actions">
          <Link className="hg-btn hg-outline hg-sm" to={invite.status === 'Draft' ? `/invites/${invite.id}/preview` : `/invite/${invite.publicToken}`}>View</Link>
          {invite.canShare && <button type="button" className="hg-btn hg-outline hg-sm" onClick={() => onShare(invite)}>Share</button>}
          {(invite.isHost || (invite.myStatus === 'Going' && invite.isApproved)) && invite.status !== 'Draft' && (
            <Link className="hg-btn hg-outline hg-sm" to={`/invites/${invite.id}/responses`}>Responses</Link>
          )}
          {invite.canChat && <Link className="hg-btn hg-gold hg-sm" to={`/invites/${invite.id}/chat`}>Chat</Link>}
          {invite.isHost && live && <button type="button" className="hg-btn hg-danger hg-sm" onClick={() => onCancel(invite)}>Cancel</button>}
        </div>
      </div>
    </article>
  );
}
